var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCombinedShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m56.8 0 .242.004A7.2 7.2 0 0 1 64 7.2v34.1l-.009.131a1 1 0 0 1-.284.576l-21.7 21.7-.099.087A1 1 0 0 1 41.3 64H7.2l-.242-.004A7.2 7.2 0 0 1 0 56.8V7.2l.004-.242A7.2 7.2 0 0 1 7.2 0h49.6zm0 2H7.2l-.22.005A5.2 5.2 0 0 0 2 7.2v49.6l.005.22A5.2 5.2 0 0 0 7.2 62l32.8-.001V41l.007-.117A1 1 0 0 1 41 40l21.001-.001L62 7.2l-.005-.22A5.2 5.2 0 0 0 56.8 2zm4.086 39.999L42 42v18.885l18.886-18.886zM32 30v2H18v-2h14zm14-8v2H18v-2h28zm0-8v2H18v-2h28z",
    fill: "#B2B8CF",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombinedShape);
export default __webpack_public_path__ + "static/media/combined-shape.81263b56.svg";
export { ForwardRef as ReactComponent };